import React from 'react';
import './Principles.css';
import motherDaughter from '../assets/images/mother-daughter.jpg.png';
import accountability from '../assets/images/accountability.png.png';
import scaleCity from '../assets/images/scale-city.jpg.png';

function Principles() {
  const principles = [
    {
      image: motherDaughter,
      title: 'Trust',
      description: 'Focused on consistent supply, disciplined operations, and strong service accountability.',
    },
    {
      image: accountability,
      title: 'Accountability',
      description: 'Built with a modern view of billing, payments, consumer support, monitoring, and field operations.',
    },
    {
      image: scaleCity,
      title: 'Scale',
      description: 'Systems and processes designed to serve growing consumer bases without compromising service quality.',
    },
  ];

  return (
    <section className="principles">
      <h2>Built on simple principles</h2>
      <p className="principles-description">
        Reliable utilities are built through trust, consistency, transparency, and execution. Eleven Power's operating philosophy is shaped by these principles.
      </p>

      <div className="principles-grid">
        {principles.map((item, index) => (
          <div key={index} className="principle-card">
            <div className="principle-image">
              <img src={item.image} alt={item.title} />
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Principles;
